import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  Media,
  Form,
  FormGroup
} from "reactstrap";
import { aggregationClicked } from "../../actions/searchActions";
import LinesEllipsis from "react-lines-ellipsis";

import checkboxNotSelected from "../../images/checkboxNotSelected.png";
import checkboxSelected from "../../images/checkboxSelected.png";

import classes from "./AggregationsCubes.module.scss";

class AggregationsCubes extends Component {
  state = {
    aggregations: []
  };

  render() {
    return (
      <Container>
        <Row>
          {this.props.aggregations.map(agg => {
            return (
              <Col lg="3" md="4" sm="6" key={agg.id} className={classes.aggCol}>
                <Form>
                  <FormGroup row>
                    <Col xs={2}>
                      <Button
                        id={"cube" + agg.id}
                        color="link"
                        onClick={() =>
                          this.props.aggregationClick(agg.id, !agg.checked)
                        }
                      >
                        <Media
                          src={
                            agg.checked ? checkboxSelected : checkboxNotSelected
                          }
                          alt="בחר פרק"
                        />
                      </Button>
                    </Col>
                    <Label for={"cube" + agg.id} xs={8}>
                      <LinesEllipsis
                        maxLine="2"
                        text={agg.name}
                        className={classes.aggText}
                      />
                    </Label>
                    <Label
                      for={"cube" + agg.id}
                      xs={2}
                      className={classes.aggNumberText}
                    >
                      ({agg.count})
                    </Label>
                  </FormGroup>
                </Form>
              </Col>
            );
          })}
        </Row>
      </Container>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    aggregationClick: (id, checked) => dispatch(aggregationClicked(id, checked))
  };
};

export default connect(null, mapDispatchToProps)(AggregationsCubes);
